
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { update, verifyReset, sendCode } from "../../comon/api/home";
export default {
data() {
return {
focus: false,
sending: false,
finish: false,
vcodeBtnTxt: "获取验证码",
toLoginBtn: "返回登录页",
username: "",
phone: "",
verifyCode: "",
newpasswd: "",
timer: null,
buttons: [{
type: 'primary',
text: '返回登录',
onClick: this.jumplogin.bind(this)
}]
};
},
components: {
XInput,
XButton,
Group,
Cell,
XHeader,
Loading,
Msg
},
created() { },
methods: {
jumplogin() {
this.$router.replace({ path: "/mobile_login" });
},

countdown(time) {
clearTimeout(this.timer);
if (time > 0) {
time--;
this.vcodeBtnTxt = time + "S后重发";
this.timer = setTimeout(() => {
this.countdown(time);
}, 1000);
} else {
this.sending = false;
this.vcodeBtnTxt = "获取验证码";
}
},

countdownToLogin(time) {
clearTimeout(this.timer);
if (time > 0) {
time--;
this.toLoginBtn = time + "s后自动跳转登录页面";
this.timer = setTimeout(() => {
this.countdownToLogin(time);
}, 1000);
} else {
this.jumplogin();
}
},

sendPhoneCode() {
if (this.phone !== "") {
this.sending = true
sendCode({
phone: (this.phone).replace(/\s+/g, "")
}).then(res => {
if (res.code == 200) {
this.countdown(60);
}
}).catch(err => {
this.sending = false
console.log(err);
});
} else {

}
},
checked() {
if (this.phone === "") {
return false
} else if (this.username === "") {
return false
} else if (this.newpasswd === "") {
return false
} else if (this.verifyCode === "") {
return false
} else {
return true
}
},

submit() {
if (this.checked()) {
this.$vux.loading.show({
text: 'Loading'
})
verifyReset({
password: this.newpasswd,
phone: (this.phone).replace(/\s+/g, ""),
username: this.username,
code: this.verifyCode
})
.then(res => {
this.$vux.loading.hide();
if (res.code == 200) {
this.countdownToLogin(5);
this.finish = true
} else {
this.$message({
showClose: true,
message: "验证码、用户名或手机号码输入错误",
type: "error"
});
}
})
.catch(err => {
console.log(err);
});
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/mobile/ForgetPwd.vue